import { render } from "./CollectionDetailedSearchMaterialsOnJapaneseEmigration.vue?vue&type=template&id=96af172e&scoped=true&ts=true"
import script from "./CollectionDetailedSearchMaterialsOnJapaneseEmigration.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchMaterialsOnJapaneseEmigration.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchMaterialsOnJapaneseEmigration.vue?vue&type=style&index=0&id=96af172e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96af172e"]])

export default __exports__